import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { FormattedMessage, injectIntl } from 'react-intl'
import { connect } from 'react-redux'

import { LoadingOverlay } from '../../../common/loading_overlay'

import { getLoginLogData, getLoginLogFetching } from '../selectors'
import * as trailersActionCreators from '../actionCreators'

import UserLoginLogListRow from './UserLoginLogListRow'
import PermissionsCheck from '../../auth/components/PermissionsCheck'
import { PERMS_LOGIN_LOG } from '../permissions'

class UserLoginLogList extends Component {
    handleExport = e => {
        e && e.preventDefault()
        this.props.actions.exportUserLoginLog(this.props.user.id)
    }

    componentDidMount() {
        if (this.props.user) {
            this.props.actions.fetchUserLoginLog(this.props.user.id)
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.user && JSON.stringify(nextProps.user) !== JSON.stringify(this.props.user)) {
            this.props.actions.fetchUserLoginLog(nextProps.user.id)
        }
    }

    render() {
        const data = this.props.data

        return (
            <PermissionsCheck hasAny={Object.values(PERMS_LOGIN_LOG)} noPermissionsTab>
                <LoadingOverlay active={this.props.fetching}>
                    {data && data.length > 0 ? (
                        <React.Fragment>
                            <div className="btns-list">
                                <PermissionsCheck has={[PERMS_LOGIN_LOG.EXPORT]}>
                                    <button className="btn btn-primary btn-addon" onClick={this.handleExport}>
                                        <i className="far fa-file-excel" /> <FormattedMessage id="buttons.exportToXLS" />
                                    </button>
                                </PermissionsCheck>
                            </div>

                            <div className="table-container table-container-no-pagination">
                                <table className="table table-striped table-hover table-fixed-header">
                                    <thead>
                                        <tr>
                                            <th className="w-30" />
                                            <th className="w-120">
                                                <FormattedMessage id="fields.dateTime" />
                                            </th>
                                            <th className="w-140">
                                                <FormattedMessage id="fields.ipAddress" />
                                            </th>
                                            <th className="w-max wm-200">
                                                <FormattedMessage id="fields.userAgent" />
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data &&
                                            data.map((item, index) => (
                                                // eslint-disable-next-line react/no-array-index-key
                                                <UserLoginLogListRow key={`row-${index}`} item={item} nextItem={data[index + 1]} />
                                            ))}
                                    </tbody>
                                </table>
                            </div>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <div className="alert alert-danger pull-left wp-100">
                                <FormattedMessage id="fields.noItemsFound" />
                            </div>
                        </React.Fragment>
                    )}
                </LoadingOverlay>
            </PermissionsCheck>
        )
    }
}

function mapStateToProps(state) {
    return {
        data: getLoginLogData(state),
        fetching: getLoginLogFetching(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            ...bindActionCreators(
                {
                    ...trailersActionCreators,
                },
                dispatch
            ),
        },
        dispatch,
    }
}

function mergeProps(stateProps, dispatchProps, ownProps) {
    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
    }
}

export default injectIntl(
    connect(
        mapStateToProps,
        mapDispatchToProps,
        mergeProps
    )(UserLoginLogList)
)
